<div class="page-container">
    <app-header></app-header>
    <div class="app-container">
        <router-outlet class="main-container"></router-outlet>
    </div>
</div>